import { render, staticRenderFns } from "./InsuranceObjectInput.vue?vue&type=template&id=1d889c4a&"
import script from "./InsuranceObjectInput.vue?vue&type=script&lang=js&"
export * from "./InsuranceObjectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports